import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  type: "text/wxtag-template",
  style: {"display":"block"}
}
const _hoisted_2 = {
  key: 0,
  class: "share-box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_wx_open_launch_weapp = _resolveComponent("wx-open-launch-weapp")!

  return (_openBlock(), _createBlock(_component_wx_open_launch_weapp, {
    id: "launch-btn",
    username: "gh_d2e8c546483e",
    path: _ctx.miniUrl
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", null, [
          _createTextVNode(" .btn { width: 100%; height: 39px; background: #FFA100; border-radius: 2px; font-size: 14px; font-family: PingFangSC-Regular, PingFang SC; font-weight: 400; color: #FFFFFF; box-sizing: border-box; border: 0; outline: none; margin-right: 11px; vertical-align: middle; } .small-btn{ background: #FFA100; width: 118px; height: 40px; border-radius: 2px; box-sizing: border-box; border: 0; outline: none; font-size: 14px; font-family: PingFangSC-Regular, PingFang SC; font-weight: 400; color: #FFFFFF; } .share-box{ width: 84px; border: 0; outline: none; background-color: transparent; display: flex; justify-content: center; align-items: center; color: #FF2F3D; font-size: 15px; padding-top: 1px; } .share-img{ width: 20px; height: 18px; } ")
        ], -1)),
        (_ctx.types === 3)
          ? (_openBlock(), _createElementBlock("button", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("img", {
                class: "share-img",
                src: "https://img.fanwoon.com/share-fill%402x.png"
              }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.strTmep), 1)
            ]))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: _normalizeClass({'btn': _ctx.types === 1, 'small-btn': _ctx.types === 2  })
            }, _toDisplayString(_ctx.strTmep), 3))
      ])
    ]),
    _: 1
  }, 8, ["path"]))
}